import useSWR from 'swr';
import { useUser, fetcher } from '../helpers/axios';

export function useUserProfile(targetUserId) {
  const { user: currentUser } = useUser();

  const shouldFetch =
    targetUserId &&
    (!currentUser || String(currentUser.id) !== String(targetUserId));

  const { data, error, isLoading } = useSWR(
    shouldFetch ? `/users/${targetUserId}/` : null,
    fetcher
  );

  return {
    user: currentUser && String(currentUser.id) === String(targetUserId)
      ? currentUser
      : data,
    loading: isLoading,
    error
  };
}
